import { createContext } from "react"

const EmployeeClassificationContext = createContext();

export default EmployeeClassificationContext;